<div
  class="dropdown"
  (document:click)="blur()"
  [ngClass]="{
    'is-active': isActive,
    'is-right': isRightAligned,
    'is-hoverable': isHoverable,
  }"
  (click)="toggle($event)"
>
  <div class="dropdown-trigger">
    <button
      class="button"
      [ngClass]="{ 'is-small': isSmall }"
      aria-haspopup="true"
      aria-controls="dropdown-menu"
    >
      <ng-content select="[header]" />
    </button>
  </div>
  <div class="dropdown-menu" id="dropdown-menu" role="menu">
    <div class="dropdown-content">
      <ng-content select="[items]" />
    </div>
  </div>
</div>
